import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import useStyles from '../../assets/styles/Sub.css';

const CategoryTitle = ({ children }: any) => {
  const classes = useStyles();
  return (
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      className={classes.appHelpAccordionTitle}
    >
      {children}
    </AccordionSummary>
  );
};

export default CategoryTitle;
